import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";

export default function GlobalLoading() {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Card>
        <CardContent>
          <Stack spacing={2} alignItems="center">
            <CircularProgress />
            <Typography>loading&hellip;</Typography>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
